import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import circleArrow from 'four-nets/icons/svg/icon_arrow-collapse.svg';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import { InterscrollerContext } from 'lib/google/dfp/ad-units/interscroller';
import { SectionCountConsumer, SiteSection } from 'lib/section-count-context/section-count-context';

import defaultStyles from './panel-group-view.scss';

export class PanelGroupViewModel {
    @observable hidden: boolean = true;

    links: CategoryLink[];
    title: string;

    constructor({ title, links }) {
        this.title = title;
        this.links = links;
    }
}

@Styled(defaultStyles)
@observer
class PanelGroupView extends React.Component {
    static contextType = InterscrollerContext;
    render() {
        const { panelGroupViewModel, onClick, styles } = this.props;

        const classNames = [styles.panelGroup];

        if (panelGroupViewModel.hidden) {
            classNames.push(styles.hidden);
        }

        const links = [...panelGroupViewModel.links]

        links.sort((a, b) => {
            return a.label.localeCompare(b.label)
        })

        return panelGroupViewModel ? (
            <div className={classNames.join(' ')}>
                <h2 className={styles.heading}>
                    <button
                        className={styles.button}
                        onClick={() => {
                            onClick(panelGroupViewModel);
                            setTimeout(this.context.updateOffsetTop, 20);
                        }}
                    >
                        <span className={styles.buttonContent}>
                            {panelGroupViewModel.title}
                            <SVGIcon style={{ image: styles.icon }} src={circleArrow} />
                        </span>
                    </button>
                </h2>

                <SectionCountConsumer>
                    {({ updateSectionCount }) => (
                        <div
                            className={classnames(styles.linksWrapper, {
                                [styles.hiddenLinksWrapper]: panelGroupViewModel.hidden,
                            })}
                            style={{
                                maxHeight: panelGroupViewModel.links.length * 40 + 10,
                            }}
                        >
                            <ul className={styles.list}>
                                {links.map(link => (
                                    <li key={link.href} className={styles.item}>
                                        <Link
                                            className={styles.link}
                                            to={link.href}
                                            onClick={() => {
                                                updateSectionCount(SiteSection.FORUM);
                                            }}
                                        >
                                            {link.label}
                                        </Link>
                                        <span className={styles.count}>
                                            ({link.threadCount}
                                            {link.newThreadCount > 0 && (
                                                <span>
                                                    , <span className={styles.newCount}>{link.newThreadCount}</span>
                                                </span>
                                            )}
                                            )
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </SectionCountConsumer>
            </div>
        ) : null;
    }
}

export default PanelGroupView;
